import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import ListItem from '@mui/material/ListItem'
import SearchIcon from '@mui/icons-material/SearchOutlined'
import SavedSearchIcon from '@mui/icons-material/SavedSearch'

import { LocationsSelector } from './Locations/LocationsSelector'
import { DatePeriodSelector } from 'src/Features/SelectedDatePeriod/DatePeriodSelector/DatePeriodSelector'
import { Button } from 'src/Components/Button'
import { useLocationsAndDatePeriodSearch } from 'src/Hooks/useLocationsAndDatePeriodSearch'
import { ErrorBoundary } from 'src/Components/ErrorBoundary'
import { StyledActionButton } from '../SidePanelMenu/StyledActionButton'

const useStyles = makeStyles()({
  searchButton: {
    padding: 10,
    marginLeft: 10,
    minWidth: 250,
    maxWidth: 250,
    borderRadius: 25,
    fontSize: 15,
  },
  searchIcon: {
    verticalAlign: 'top',
  },
})

type OwnProps = {
  onSaveSearch?: () => void
  hideSaveAndSearchButton?: boolean
}

export const LocationsAndDatePeriodSelector = ({ onSaveSearch, hideSaveAndSearchButton }: OwnProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  const { searchDisabled, triggerSearch } = useLocationsAndDatePeriodSearch()

  const onSearchAndSave = useCallback(() => {
    triggerSearch()
    onSaveSearch?.()
  }, [triggerSearch, onSaveSearch])

  return (
    <>
      <ListItem>
        <ErrorBoundary>
          <LocationsSelector />
        </ErrorBoundary>
      </ListItem>
      <ListItem>
        <ErrorBoundary>
          <DatePeriodSelector />
        </ErrorBoundary>
      </ListItem>
      <ListItem>
        <Button
          buttonClass={classes.searchButton}
          disabled={searchDisabled}
          onClick={triggerSearch}
          data-testid="LocationsAndPeriodSearchButton"
          endIcon={<SearchIcon className={classes.searchIcon} />}
        >
          {t('general.search')}
        </Button>
      </ListItem>
      <ListItem>
        <StyledActionButton
          buttonClass={classes.searchButton}
          disabled={searchDisabled}
          hidden={hideSaveAndSearchButton}
          onClick={onSearchAndSave}
          endIcon={<SavedSearchIcon className={classes.searchIcon} />}
          variant="outlined"
          title={t('pageFilters.searchAndSaveStartPageTitle')}
        >
          {t('pageFilters.searchAndSave')}
        </StyledActionButton>
      </ListItem>
    </>
  )
}
